import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { GrowlModule } from 'primeng/components/growl/growl';
import { DialogModule } from 'primeng/components/dialog/dialog';
import { PanelModule } from 'primeng/panel';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/primeng';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { LandingModule } from './landing/landing.module';
import {
  AccountService,
  AppConfig,
  CategoryService,
  ChangeFiltersService,
  CookbookService,
  CookieService,
  FilesService,
  PopupService,
  ProfileService,
  RestService,
  SharedModule,
  SpinnerService,
  PlanningService,
  HelperService,
  DatepickerService,
  LowerCaseUrlSerializer,
  IntroService
} from './shared/shared.module';
import { MetrikaModule } from 'ng-yandex-metrika';
import { AuthGuard } from './shared/services/auth.guard';
import { UiComponent } from './ui/ui.component';
import {FormsModule} from '@angular/forms';
import {RouterModule, UrlSerializer} from '@angular/router';
import {DatepickerModule} from '@app/datepicker/datepicker.module';
import {AngularInterceptor} from '@app/shared/interceptors/http-interceptor';

// Загрузка конфига при старте проекта
export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}

@NgModule({
  declarations: [
    AppComponent,
    UiComponent,
  ],
  imports: [
    RouterModule,
    HttpClientModule,
    LandingModule,
    FormsModule,
    AuthModule,
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    AppRoutingModule,
    DatepickerModule,
    // Задание дефолтного счётчика
    MetrikaModule.forRoot({
      id: 48761390,
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true
    }),
    GrowlModule,
    DialogModule,
    PanelModule,
    BlockUIModule,
    ProgressSpinnerModule
  ],
  exports: [],
  providers: [
    FilesService,
    CategoryService,
    CookbookService,
    PopupService,
    PlanningService,
    AccountService,
    RestService,
    CookieService,
    ChangeFiltersService,
    RestService,
    PopupService,
    SpinnerService,
    ProfileService,
    AuthGuard,
    DatepickerService,
    HelperService,
    AppConfig,
    IntroService,
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig], multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AngularInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts